<ion-row>
  <ion-text [innerHTML]="translationKey + '.win_dialog.text'|translate:{ correctAnswers: correctAnswers, totalQuestions: totalQuestions, percentCorrect: percentCorrect, timeString: timeString }"></ion-text>
</ion-row>
